// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundViewOutlinedSvg from "@fishx/icons-svg/es/asn/FundViewOutlined";
import FishxIcon from '../components/FishxIcon';

var FundViewOutlined = function FundViewOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundViewOutlinedSvg
  }));
};

FundViewOutlined.displayName = 'FundViewOutlined';
export default React.forwardRef(FundViewOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FundViewOutlined.js
// module id = 2856
// module chunks = 0